var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclethink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2793 21.8446C64.3501 4.90493 45.2505 -1.9786 31.9982 4.27741C18.0548 10.852 14.6782 29.9991 21.3467 43.3042C27.8165 56.2176 43.5948 63.3719 57.2969 59.5718C71.0936 55.7494 82.198 40.9981 78.5998 32.2447C74.8841 23.2016 56.2246 22.3702 43.9826 25.7371C27.0016 30.4227 10.6399 46.4418 14.0263 57.6192C16.4513 65.6144 28.2271 68.5322 39.3218 71.2811C47.4505 73.2943 71.954 79.3655 81.2626 67.3791C84.9521 62.6297 86.0505 55.3098 83.9255 49.8119C75.699 28.502 25.0786 13.276 7.36756 34.2037C-2.08443 45.3843 -0.490634 65.1493 8.70062 83",
    stroke: "#0D4E32",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclethink);
export default __webpack_public_path__ + "static/media/circlethink.00bfc31cc777ac27949a875667351f30.svg";
export { ForwardRef as ReactComponent };